export type GetProjectParams = {
  projectId: string
}

export type GetProjectCaseParams = {
  projectId: string
}

export type GetProjectStatistics = {
  projectId: string
}

export type GetProjectMetrics = {
  projectId: string
}

export type GetProjectFilesParams = {
  projectId: string
}

export type GetProjectMembersParams = {
  projectId: string
}

export type UpdateProjectParams = {
  projectId: string
}

export type UploadProjectFileParams = {
  projectId: string
}

export type GetWebsiteSpeedParams = {
  projectId: string
}

export type GetWebsiteContentParams = {
  projectId: string
}

export type GetWebsiteEnvironmentParams = {
  projectId: string
}

const endpoints = {
  getProjects: `api/v2/users/user-id/projects/`,
  createProject: `api/v2/users/user-id/projects/`,
  updateProject: ({ projectId }: UpdateProjectParams): string => {
    return `api/v2/users/user-id/projects/${projectId}`
  },
  getProject: ({ projectId }: GetProjectParams): string => {
    return `api/v2/users/user-id/projects/${projectId}`
  },
  getProjectCase: ({ projectId }: GetProjectCaseParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/case`
  },
  getStatistics: ({ projectId }: GetProjectStatistics): string => {
    return `api/v2/users/user-id/projects/${projectId}/statistics`
  },
  getProjectMetrics: ({ projectId }: GetProjectMetrics): string => {
    return `api/v2/users/user-id/projects/${projectId}/metrics/`
  },
  getProjectFiles: ({ projectId }: GetProjectFilesParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/files`
  },
  getProjectMembers: ({ projectId }: GetProjectMembersParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/members`
  },
  uploadProjectFile: ({ projectId }: UploadProjectFileParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/storage/files/`
  },
  getWebsiteSpeed: ({ projectId }: GetWebsiteSpeedParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/website/speed`
  },
  getWebsiteContent: ({ projectId }: GetWebsiteContentParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/website/content/`
  },
  getWebsiteEnvironment: ({ projectId }: GetWebsiteEnvironmentParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/website/environment/`
  },
}

export default endpoints
